export default __webpack_public_path__ + "static/media/awards-player-header.a1bb1de6.png";